<template>
  <div class="container">
    <van-nav-bar
      title="签到中心"
      fixed
      :placeholder="true"
      :z-index="99"
      left-arrow
      @click-left="goBack"
    />
    <div class="head" v-if="member != null">
      <div class="left">
        <van-image class="head-img" round width="5rem" height="5rem" :src="member.HeadPic" />
      </div>
      <div class="right">
        <div class="nickName">{{ member.NickName }}</div>
        <div>ID:{{ member.SerialNumber }}</div>
        <div class="desc">
          <!-- <span class="ye">余额:{{member.HasCash}}</span> -->
          <span class="ye">孝爱币:{{member.HasCoin}}</span>
          <span>孝心:{{ member.XiaoAiIntegral }}</span>
        </div>
      </div>
    </div>
    <div class="content" v-if="member != null">
      <div class="top">
        <div class="tip">
          <div class="title">每日签到</div>
          <div class="text">
            你已连续连续签到<span class="number">{{ member.SignInCount }}</span
            >天
          </div>
        </div>
        <div class="join" v-if="!isSign" @click="onSignIn">
          <div></div>
          <div>签到</div>
        </div>
        <div class="join-disable" v-else>
          <div></div>
          <div>已签到</div>
        </div>
      </div>
      <van-calendar
        title="日历"
        color="#1989fa"
        :min-date="minDate"
        :max-date="maxDate"
        :show-title="false"
        :readonly="false"
        :poppable="false"
        :show-confirm="false"
        :formatter="formatter"
      />
    </div>
    <div class="foot" v-if="member != null">
      <p class="title">签到说明</p>
      <ul class="list">
        <li class="item">1、首次创建纪念馆可获取1000孝爱币；</li>
        <li class="item">2、每日签到可获取孝心与孝爱币，连续签到可获取更多孝心与孝爱币；</li>
        <li class="item">
          3、当月连续签到1天~7天，可以对应获取1~7个孝心与孝爱币连续签到7天后，每天可以获取5个孝爱币和5个孝心；
        </li>
        <li class="item">
          4、孝爱币可以直接消费虚拟产品以及纪念馆升级服务；
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { Calendar } from "vant";
import { Toast } from "vant";

var _selectDate = [];
export default {
  data() {
    return {
      isSign: false,
      member: null,
      minDate: new Date(),
      maxDate: new Date(),
      dataList: null,
    };
  },
  components: {
    [Calendar.name]: Calendar,
  },
  mounted() {
    var date = new Date();
    date.setDate(1);
    // var firstDay = date.toLocaleDateString();
    this.minDate = date;
    date = new Date();
    date.setMonth(date.getMonth() + 1);
    date.setDate(0);
    // var lastDay = date.toLocaleDateString();
    this.maxDate = date;
  },
  methods: {
    init() {
      this.GetMemberInfo();
      this.getSignInList();
    },
    GetMemberInfo() {
      var that = this;
      that.$store
        .dispatch({
          type: "GetMemberInfo",
        })
        .then((res) => {
          //console.log(res, "GetMemberInfo");
          that.member = res;
          that.isSign = res.IsSignIn;
        });
    },
    getSignInList() {
      var that = this;
      that.$store
        .dispatch({
          type: "getSignInList",
        })
        .then((res) => {
          //console.log(res,"getSignInList");
          that.dataList = res;
        });
    },
    formatter(day) {
      const month = day.date.getMonth() + 1;
      const date = day.date.getDate();
      const nowDate = new Date();
      var _findData = _selectDate.filter((x) => x == date);
      if (_findData.length == 0) {
        if (this.dataList != null && this.dataList.length > 0) {
          var _isFind = false;
          this.dataList.forEach((x) => {
            var _time = new Date(x.AddDateTime);
            if (date == _time.getDate()) {
              _selectDate.push(date);
              day.bottomInfo = "已签到";
              day.className = "dayGreen";
              day.type = "disabled";
              _isFind = true;
            }
            if (!_isFind) {
              if (nowDate.getDate() >= date) {
                day.bottomInfo = "未签到";
                day.className = "dayRed";
                day.type = "disabled";
              } else {
                day.type = "disabled";
              }
            }
          });
        } else {
          if (date == nowDate.getDate()) {
            day.text = "签";
            day.bottomInfo = "今天";
            day.className = "day";
          } else {
            if (nowDate.getDate() >= date) {
              day.bottomInfo = "未签到";
              day.className = "dayRed";
              day.type = "disabled";
            } else {
              day.type = "disabled";
            }
          }
        }
      }
      return day;
    },
    onSignIn() {
      _selectDate=[];
      var that = this;
      that.$store
        .dispatch({
          type: "SignInPost",
        })
        .then((res) => {
          if (res.IsSuccess) {
            Toast(res.Message);
            that.isSign = true;
            that.init();
          } else {
            Toast(res.Message);
          }
        });
    },
    goBack() {
      this.$router.go(-1);
    },
  },
  created() {
    this.init();
  },
};
</script>

<style lang="less" scoped>
.container {
  display: flex;
  flex-direction: column;
  .head {
    display: flex;
    flex-direction: row;
    background-color: #24a378;
    padding: 20px;
    color: white;
    height: 15rem;
    .head-img{
      border: 3px solid rgba(255, 255, 255, 0.4);
    }
    .left {
      flex: 1;
    }
    .right {
      margin-left: 10px;
      flex: 3;
      .nickName {
        font-size: 18px;
      }
      .desc {
        .ye {
          margin-right: 25px;
        }
      }
    }
  }
  .content {
    margin: 15px;
    position: relative;
    top: -130px;
    background-color: #f5f5f5;
    padding: 15px;
    border-radius: 10px;
    .top {
      display: flex;
      flex-direction: row;
      margin: 0px 0px 5px 0px;
      padding: 5px;
      .tip {
        flex: 3;
        .title {
          font-size: 16px;
          font-weight: 600;
        }
        .text {
          color: #737673;
          .number {
            color: red;
          }
        }
      }
      .join {
        flex: 1;
        text-align: right;
        background-color: #1989fa;
        display: flex;
        justify-content: center;
        align-items: center;
        color: white;
        border-radius: 10px;
      }
      .join-disable {
        flex: 1;
        text-align: right;
        background-color: silver;
        display: flex;
        justify-content: center;
        align-items: center;
        color: white;
        border-radius: 10px;
      }
    }
  }
  .foot {
    position: relative;
    top: -150px;
    padding: 15px;
    color: #8f918f;
    .title {
      font-size: 16px;
      font-weight: 600;
      color: black;
    }
    .list {
      margin-top: 10px;
      .item {
        padding: 1px 0px;
      }
    }
  }
}


</style>
<style >
.day {
  color: #007aff;
}
.dayRed {
  color: red;
}
.dayGreen {
  color: green;
}
</style>

